<template>
  <v-card>
    <v-toolbar dark color="success">
      <v-btn icon dark @click="closeDialog">
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>Lista de Documentos Adjuntos</v-toolbar-title>
      <!-- <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark flat>Descargar</v-btn>
      </v-toolbar-items> -->
    </v-toolbar>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs12 v-for="(datos, i) in mostrarDatos" :key="i">
            <detalleAdjuntos
              :datos="datos"
            />
          </v-flex>
          <!-- <pre>Mostrar: {{ mostrarDatos }}</pre> -->
          <!-- <pre>filtro1: {{ filtro1 }}</pre> -->
        </v-layout>
      </v-container>
    </v-card-text>
    <!-- <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="closeDialog">Cerrar</v-btn>
    </v-card-actions> -->
  </v-card>
</template>

<script>
import detalleAdjuntos from "./documentos-adjuntos-detalle" 
export default {
  name: "ListaDocumentos",
  props: ["datos", "debug"],
  components: {
    detalleAdjuntos
  },
  data() {
    return {
      
    }
  },

  computed: {
    filtro1() {
      let result = []
      if (this.datos && this.datos.length > 0) {
        result = this.datos.map(i => {
          return {
            key: i.key,
            direccion: `Escalera: ${i.dataBurbuja.escalera || ' - '}, Planta: ${i.dataBurbuja.piso || ' - '}, Letra: ${i.dataBurbuja.letra || ' - '}`,
            propietarios: i.dataBurbuja.propietarios
          }
        })
      }
      return result
    },

    mostrarDatos() {
      let result = []
      this.filtro1.forEach(e => {
        const key = e.key
        const direccion = e.direccion
        const propietarios = e.propietarios || []
        let filesProp = []
        for (let index = 0; index < propietarios.length; index++) {
          const propietario = propietarios[index];
          const files = this.filesIn(propietario)
          let resultFiles = []
          if (files && files.length > 0) {
            files.forEach(fileName => {
              const f = propietario.data[fileName]
              if (f.length > 0) {
                resultFiles.push({
                  name: fileName,
                  files: f
                })
              }
            });
            if (resultFiles.length > 0) {
              filesProp.push({
                nombre: this.extraeNombre(propietario),
                files: resultFiles
              })
            }
          }
        }
        if (filesProp.length > 0) {
          result.push({
            key: e.key,
            direccion: e.direccion,
            propietarios: filesProp
          })
        }
      });
      return result
    },

    /* mostrarDatos() {
      let result = ['No hay datos...']
      if (this.filtro1 && this.filtro1.length > 0) {

        result = this.filtro1.filter(i => {
          const keys = Object.keys(i.propietarios.data)
          return keys.some(e => e.indexOf("file"))
        })
      }
      return result
    } */
  },

  methods: {
    extraeNombre(propietario) {
      let result = ' - Sin Datos -'
      if (!propietario || !propietario.data) {
        return result
      }
      const datos = propietario.data
      if(datos.calificacionJuridica === '1'){
        const data = datos.pFisica
        const parcial = `${data.nombre} ${data.apellido1} ${data.apellido2}`
        result = parcial.length > 3 ? parcial : result
      } else {
        const data = datos.pJuridica
        result = data.razonSocial && data.razonSocial.length > 0 ? data.razonSocial : result
      }
      return result
    },

    filesIn(propietario) {
      if (!propietario || !propietario.data) {
        return []
      }
      const keys = Object.keys(propietario.data)
      return keys.filter(i => {
        return !i.search("file")
      })
    },

    closeDialog() {
      this.$emit("closeDialog")
    },

    descargar(file) {
      //ONCLICK="document.location='ruta/fichero.rar'"
    }
  }
};
</script>
